import React, { useCallback } from 'react';
import { ACTIVE_TABS } from './constants';

export default function Abas({ activeTab = '', onTabChange }) {
  const classActive = useCallback(
    (tab = ACTIVE_TABS.BILHETAGEM) => {
      return tab === activeTab ? 'btn-primary' : 'btn-outline-primary';
    },
    [activeTab],
  );
  return (
    <div style={{ marginBottom: '20px' }}>
      <div className="btn-group " role="group">
        <button
          type="button"
          className={`btn ${classActive(ACTIVE_TABS.BILHETAGEM)}`}
          onClick={() => onTabChange(ACTIVE_TABS.BILHETAGEM)}
        >
          Calculadoras e consultas
        </button>
        <button
          type="button"
          className={`btn ${classActive(ACTIVE_TABS.OUTROS)}`}
          onClick={() => onTabChange(ACTIVE_TABS.OUTROS)}
        >
          Outros
        </button>
      </div>
    </div>
  );
}
